import React from 'react'
import './Company.css'
import Footer from '../../components/Footer/Footer';

const Company = () => {
  return (
   <div>

    <section className="home sectionClass" id="home"  >
<div className="content">
    <h4>Meet our Team</h4>
    <p>Agil 4 you   was founded in 2018.
     Since that time we successfully created several very effective and successful apps for Atlassian Jira.
     The AGIL4YOU company currently has its main establishment in MANTES-LA-JOLIE (company headquarters). It is the establishment where the administration and effective management of the company are centralized.
     </p>
    
</div>

<div className="image">
    <img src="./assets/company1.jpg" alt=""  width="20%" height="20%"/>
</div>

</section>
<Footer/>
<section>
  
</section>
</div>
    
  )
}

export default Company
